import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { hasAcceptedCurrentAgreement } from "@/lib/sellerAgreement";

/**
 * Whether the current seller still has to accept the current Seller Agreement
 * version. Shares its query key with the seller onboarding query so a single
 * fetch serves the route guard and the dashboard.
 */
export function useSellerAgreementStatus() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["seller", "onboarding", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("seller_onboarding")
        .select(
          "current_step, completed, seller_agreement_accepted_at, seller_agreement_version"
        )
        .eq("user_id", user!.id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    enabled: !!user?.id,
  });

  const needsAgreement =
    !!user &&
    !isLoading &&
    !hasAcceptedCurrentAgreement(
      data?.seller_agreement_accepted_at,
      data?.seller_agreement_version
    );

  return { needsAgreement, loading: isLoading };
}
